import { render } from "./DeviceSettingsModal.vue?vue&type=template&id=c7c131bc"
import script from "./DeviceSettingsModal.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script